import { call, put, select, takeLatest } from 'redux-saga/effects';

import isEmpty from 'lodash/isEmpty';

import { addCustomGTMEvent } from '../../../events';
import { formatError } from '../../../libs';
import cartAPI from '../../api/cart';
import { Creators as CartCreators, Types } from '../../reducers/cart';
import { Creators as FreigthsCreators } from '../../reducers/freights';
import { Creators as StoresCreators } from '../../reducers/stores';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* changeQuantity({ product, changeType, sellerId }) {
  try {
    const {
      app,
      cart: { id: cartId },
      customer,
      freights: { cartFreight },
    } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);
    const { id, quantity, isKit } = product;
    const token = yield select(getToken);
    const type = isKit ? 'kit' : 'line';
    const isChangeQuantity = true;
    const body = { quantity };

    const validCartId = cartId || customer.cartId || getCartId();

    const data = yield call(cartAPI.changeQuantity, validCartId, id, type, body, token, siteId);

    yield put(CartCreators.changeQuantitySuccess({ id, data }));

    if (!isEmpty(cartFreight)) {
      yield put(FreigthsCreators.cartFreightRequest(null, { filter: 'lowerPrice', idSeller: sellerId }));
      yield put(StoresCreators.storesRequest(null, null, isChangeQuantity));
    }

    if (data?.sellers?.length !== 0) {
      const seller = data?.sellers[0];
      const modifiedProduct = seller?.lines?.find((line) => line?.id === id);
      const dataLayerPayload = {
        currency: 'BRL',
        value: modifiedProduct?.product?.price,
        items: [
          {
            item_id: modifiedProduct?.product?.id,
            item_name: modifiedProduct?.product?.name,
            affiliation: seller?.seller?.name,
            quantity: modifiedProduct?.quantity,
          },
        ],
      };

      addCustomGTMEvent({
        event: `success_${changeType === 'remove' ? 'remove_from' : 'add_to'}_cart`,
        data: dataLayerPayload,
        clear: true,
      });
    }
  } catch (error) {
    addCustomGTMEvent({
      event: `error_cart`,
      data: {
        message: formatError(error),
      },
      clear: true,
    });
    yield put(CartCreators.changeQuantityError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CHANGE_QUANTITY_REQUEST, changeQuantity);
}
